import React, { useState } from 'react';
import { Box, Paper, Collapse, IconButton, useTheme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const CollapsibleMobileCard = ({ 
  headerLeft, 
  headerBadge, 
  headerRight, 
  children,
  defaultExpanded = false
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const theme = useTheme();

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        mb: 2,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
        transition: 'all 0.3s ease'
      }}
    >
      {/* Header (Always Visible) */}
      <Box
        onClick={handleToggle}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 1.5,
          cursor: 'pointer',
          backgroundColor: expanded 
            ? theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)'
            : 'transparent'
        }}
      >
        {/* Left: Main Identifier */}
        <Box sx={{ 
          flex: 1, 
          display: 'flex', 
          alignItems: 'center', 
          overflow: 'hidden',
          minWidth: 0, // important for text truncation inside flex
          mr: 1
        }}>
          {headerLeft}
        </Box>

        {/* Center: Badge */}
        {headerBadge && (
          <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0, mr: 1 }}>
            {headerBadge}
          </Box>
        )}

        {/* Right: Value + Chevron */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
          {headerRight}
          <IconButton 
            size="small" 
            disableRipple
            sx={{ p: 0, color: 'text.secondary' }}
          >
            {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Box>
      </Box>

      {/* Expandable Body */}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Box sx={{ 
          px: 2,
          pb: 2,
          borderTop: `1px solid ${theme.palette.divider}`
        }}>
          <Box sx={{ pt: 2 }}>
            {children}
          </Box>
        </Box>
      </Collapse>
    </Paper>
  );
};

export default CollapsibleMobileCard;
